import { RawShaderMaterial, Vector4, DoubleSide } from 'three'

import raf from '@internet/raf'

import Assets from '../../controllers/Assets'

import vert from './coin-material.vert'
import frag from './coin-material.frag'
import { Vector3 } from 'three'
import { Color } from 'three'

export default class CoinMaterial extends RawShaderMaterial {

	constructor( {color} = props) {
		super({
			vertexShader: vert,
			fragmentShader: frag,
			uniforms: {
				color: { value: color || new Color(0x0000FF)  },
			},
			// opacity: 1.,
			// depthWrite: false,
			// transparent: true,
		})
	}

}
